import { gql } from 'graphql-request';

const UpdateRestrictionFilterQuery = gql`
  mutation UpdateRestrictionFilter($input: UpdateRestrictionBusinessParams!) {
    UpdateRestrictionFilter(input: $input) {
      status
      error
      messege
      data
    }
  }
`;
export default UpdateRestrictionFilterQuery; 